<template>
  <div id="dossierWrapper">
    <loading-notification
      v-if="!source"
      message="Het kwalificatiedossier wordt geladen...">
    </loading-notification>

    <div v-else class="columns" id="dossier">
      <div class="column">
        <my-title>
          {{ source.nr }} - {{ source.name }}

          <button
            v-if="isAdmin(account)"
            class="button"
            @click="reloadDefaults(source.nr)">

            <span class="icon">
              <i
                class="fas fa-redo"
                :class="{ 'fa-spin': reloading }"></i>
            </span>
          </button>
        </my-title>

        <div v-show="!enableQuestionEditing()" class="notification is-warning">
          Dit dossier is niet gekoppeld aan een bundel, een beheerder moet het dossier eerst koppelen aan minimaal 1 bundel voordat er leervragen aan toegevoegd kunnen worden.
        </div>

        <div class="tabs">
          <ul>
            <li :class="{'is-active': activeTab === 1}"><a @click="switchTab(1)">Omschrijving</a></li>
            <li :class="{'is-active': activeTab === 2}"><a @click="switchTab(2)">Gedrag</a></li>
            <li :class="{'is-active': activeTab === 3}"><a @click="switchTab(3)">Kennis en vaardigheden</a></li>
          </ul>

          <ul id="toggleAll" class="is-pulled-right">
            <li @click="toggleAllOpened">
              <span class="icon">
                <i class="fas" :class="(allOpened) ? 'fa-chevron-down' : 'fa-chevron-left'"></i>
              </span>
            </li>
          </ul>
        </div>

        <dossier-item
          v-for="item in (activeTab === 3) ? source.kennisenvaardigheden : source.werkprocessen"
          :key="item.nr"
          :item="item"
          :isOpened="allOpened"
          :activeSource="activeTab"
        ></dossier-item>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { authMixin } from "@/mixins";
import MyTitle from '@/components/modules/Title'
import DossierItem from '@/components/dossiers/DossierItem'
import LoadingNotification from '@/components/modules/LoadingNotification'

export default {
  name: 'Dossier',
  mixins: [
    authMixin
  ],
  beforeRouteLeave (to, from, next) {
    this.$store.commit('dossiers/RESET')
    next()
  },
  components: {
    MyTitle,
    DossierItem,
    LoadingNotification
  },
  props: [
    'nr'
  ],
  data () {
    return {
      words: [],
      query: null,
      activeTab: 1,
      allOpened: false
    }
  },
  computed: {
    ...mapGetters({
      source: 'dossiers/source',
      account: 'account/account',
      dossier: 'dossiers/dossier',
      excludes: 'excludes/excludes',
      questions: 'values/questions',
      reloading: 'values/reloading'
    })
  },
  created () {
    this.$store.dispatch('dossiers/find', {
      nr: this.nr
    })

    this.$store.dispatch('dossiers/load', {
      nr: this.nr
    })

    this.$store.dispatch('values/loadQuestions', {
      nr: this.nr,
      admin: this.inAdmin
    })
  },
  beforeDestroy () {
    this.$store.commit('dossiers/PURGE_DOSSIER')
  },
  methods: {
    toggleAllOpened () {
      this.allOpened = !this.allOpened
    },
    enableQuestionEditing () {
      if (this.dossier.id) {
        return (!this.inAdmin) ? this.dossier.bundles.length > 0 : true
      }

      return false
    },
    switchTab (index) {
      this.activeTab = index
    },
    getClass (index) {
      return this.activeGroup === index ? 'fas fa-caret-down' : 'fas fa-caret-left'
    },
    reloadDefaults (dossierNr) {
      this.$store.dispatch('values/reloadDefaults', dossierNr)
    },
    bulkAdd (mode) {
      let self = this

      if (this.result.length > 0) {
        this.result.map(function (word, i) {
          let group = (mode === 1 && i > 0) ? `group_${self.groups.length - 1}` : 'newGroup'
          let idx = self.words.findIndex(x => x.phrase === word.phrase)

          if (word.checked) {
            self.setTransit(idx)
            self.getTransit(group, {
              addedIndex: 0
            })
            self.removeWord(self.words, idx)
          }
        })

        if (this.result.length === 0) {
          self.query = null
        }
      }
    },
    save () {
      this.$store.dispatch('phrases/save', {
        phrases: this.groups,
        number: this.nr
      })
    }
  }
}
</script>

<style scoped>
  #toggleAll {
    width: 48px;
    flex-grow: 0;
  }
</style>
